export default __webpack_public_path__ + "static/media/Eshita.7ba0027d.jpeg";